import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import MultiSelect from '@adv-mt/mt-form-filter-multi-select'

const LEGACY_WRAPPER = 'legacy'

const DEFAULT_COMMITMENT_OPTIONS = [0, 3, 12, 24, 36]

const FormSubscriptionCommitment = ({
  onChange,
  options = DEFAULT_COMMITMENT_OPTIONS,
  overlayContentRef,
  type,
  value = [],
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {DEFAULT_SUBSCRIPTION_COMMITMENT_SEARCH} = config.get('searchFilters')

  const label = i18n.t('COMMON.COMMITMENT')
  const placeholder = i18n.t('COMMON.COMMITMENTS_ALL')

  const localizeOptionsLabel = option => ({
    id: option,
    label: option ? i18n.t('COMMON_N_MONTHS', option) : i18n.t('COMMON.COMMITMENT_NONE')
  })

  const localizedCommitments = options.map(localizeOptionsLabel)

  const _handleChange = (e, {value}) => {
    const newValue = Array.isArray(value) ? value : [value]

    onChange(e, {
      field: FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT,
      value: newValue.map(Number),
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]
    })
  }

  const handleReset = () => {
    onChange(null, {
      field: FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT,
      value: DEFAULT_SUBSCRIPTION_COMMITMENT_SEARCH
    })
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <MultiSelect
        label={label}
        options={localizedCommitments}
        value={value}
        placeholder={placeholder}
        onChange={_handleChange}
      />
    )
  }

  const _getPlaceholder = () => {
    if (value.length) return value.map(commitment => i18n.t('COMMON_N_MONTHS', commitment)).join(', ')
    return withLabel ? i18n.t('COMMON.ALL') : i18n.t('COMMON.COMMITMENT')
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON.ALL'),
          name: FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT,
          options: localizedCommitments,
          type
        }
      ]}
      group={`${FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT}Group`}
      legend={withLabel && i18n.t('COMMON.COMMITMENT')}
      onChange={({value}) => {
        _handleChange(null, {value: value.filter(id => id !== allSelectionsId)})
      }}
      onReset={handleReset}
      overlayContentRef={overlayContentRef}
      placeholder={_getPlaceholder()}
      showLegend={withLabel}
      value={{[FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: value.length ? value : [allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormSubscriptionCommitment.displayName = 'FormSubscriptionCommitment'
FormSubscriptionCommitment.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.number,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormSubscriptionCommitment
